import { Component } from '@angular/core';
import { TranslateService } from "@ngx-translate/core";
import { HttpErrorResponse } from "@angular/common/http";

import { MessageService as PrimeMessageService } from "primeng/api";
import { AdministrationCleanupService } from "@app/services/net-remit/administration.cleanup.service";

import { CleanupTaskView } from "@app/shared/models/administration/cleanup/CleanupTaskView";

import { finalize, takeWhile } from "rxjs/operators";
import {DatePipe} from '@angular/common';

@Component({
    selector: 'app-administration-data-cleanup-log-form',
    templateUrl: './data-cleanup-log-form.component.html',
    styleUrls: ['./data-cleanup-log-form.component.scss'],
    standalone: false
})
export class DataCleanupLogFormComponent {

  public alive: boolean = true;
  public isError: boolean;
  public isLoading: boolean = true;
  public cleanupLogs: Array<CleanupTaskView> = [];

  constructor(
    private cleanupService: AdministrationCleanupService,
    private primeMessageService: PrimeMessageService,
    private translate: TranslateService
  ) {}

  ngOnInit(){
    this.getDataCleanupLog();
  }

  private getDataCleanupLog(){
    setTimeout(() => {
      this.cleanupService.getCleanupTasksLogData()
        .pipe(finalize(() => this.isLoading = false ), takeWhile(() => this.alive))
        .subscribe({
          next: (cleanupLogs: CleanupTaskView[]) => {
            this.cleanupLogs = cleanupLogs;
            this.cleanupLogs.map((c: CleanupTaskView) => c.status = this.transformStatus(c.status));
            this.cleanupLogs.map((c: CleanupTaskView) => c.executeTimeAux = this.transformDate(c.executeTime));
          },
          error: (error: HttpErrorResponse) => {
            this.isError = true;
            this.primeMessageService.add({
              sticky: true,
              severity: 'error',
              summary: this.translate.instant('Modal.Error'),
              detail: this.translate.instant(error.error)
            });
          }
        });
    },2000)
  }

  ngOnDestroy(): void {
    // prevent memory leak when component destroyed
    this.alive = false;
  }

  private transformStatus(key: string): any {
    if(key && typeof key === 'string'){
      switch(key){
        // E=Error, S=Success, L=Launched y W=Working
        case "E":
          return this.translate.instant("Administration.Cleanup.Status.Error");
        case "L":
          return this.translate.instant("Administration.Cleanup.Status.Launched");
        case "S":
          return this.translate.instant("Administration.Cleanup.Status.Success");
        case "W":
          return this.translate.instant("Administration.Cleanup.Status.Working");
        default:
          console.log("Key does not exist into the context");
          return "";
      }
    }
    return "Incorrect format";
  }

  private transformDate(dateString: Date, format: string = 'yyyy/MM/dd HH:mm'): string {
    const datePipe = new DatePipe('en-US');
    const transformedDate = datePipe.transform(dateString, format);
    return transformedDate ? transformedDate : 'Incorrect format';
  }
}
